import request from '../utils/request';

const BASE_URL = '/quality-inspection';

export const qualityInspectionApi = {
  // 分页查询质检列表
  pageQualityInspections: (page = 1, pageSize = 10, queryParams = {}) => {
    return request.post(`${BASE_URL}/page`, 
     {
        page,
        pageSize,
        ...queryParams
      }
    );
  },

  // 分页查询质检列表（按订单分组）
  pageOrderGroupedQualityInspections: (queryParams = null) => {
    return request.post(`${BASE_URL}/page/order-grouped`, queryParams);
  },

  // 分页查询质检列表
  pageQualityInspectionList: (queryParams = null) => {
    return request.post(`${BASE_URL}/page/list`, queryParams);
  },

  // 添加质检记录
  addQualityInspection: (qualityInspectionData) => {
    return request.post(BASE_URL, qualityInspectionData);
  },

  // 更新质检记录
  updateQualityInspection: (qualityInspectionId, qualityInspectionData) => {
    return request.put(`${BASE_URL}/${qualityInspectionId}`, qualityInspectionData);
  },

  // 删除质检记录
  deleteQualityInspection: (qualityInspectionId) => {
    return request.delete(`${BASE_URL}/${qualityInspectionId}`);
  },

  // 获取质检记录详情
  getQualityInspectionDetail: (qualityInspectionId) => {
    return request.get(`${BASE_URL}/${qualityInspectionId}`);
  },

  // 平台确认收货
  confirmPlatformReceipt: (data) => {

    return request.post(`/goods-order/platform/confirm/receipt`, data);
  },

  // 平台送检
  sendForInspection: (data) => {
    return request.post(`/goods-order/platform/send/inspection`, data);
  },

  // 平台上传质检结果
  uploadInspectionResult: (data) => {
    return request.post(`/goods-order/platform/upload/inspection`, data);
  }
};
